// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1XWWT","container":"styles_container__11XWq","title":"styles_title__2aW1I","wrapper":"styles_wrapper__2JT3A","answer":"styles_answer__2Am0V"};